'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var DEFAULTS = {
  duration: 100,
  orientation: 'vertical'
};

exports.default = function (node, newValue, config, // or callback
callback) {
  if (typeof config === 'function') {
    callback = config;
    config = null;
  }
  if (!config) {
    config = DEFAULTS;
  }
  var _config = config,
      orientation = _config.orientation;
  var _config2 = config,
      duration = _config2.duration;


  var horiz = orientation == 'horizontal';
  var scrollPosName = horiz ? 'scrollLeft' : 'scrollTop';

  var currentValue = node[scrollPosName];

  var diff = newValue - currentValue;

  var now = Date.now();
  duration = duration != null ? duration : 100;
  var millisecondStep = diff / duration;

  if (!duration) {
    node[scrollPosName] = newValue;
    if (typeof callback === 'function') {
      callback(newValue);
    }
    return;
  }

  var scroll = function scroll() {
    var elapsed = Date.now() - now;
    node[scrollPosName] = currentValue + elapsed * millisecondStep;

    if (elapsed < duration) {
      global.requestAnimationFrame(scroll);
    } else {
      node[scrollPosName] = newValue;
      if (typeof callback === 'function') {
        callback(newValue);
      }
    }
  };

  global.requestAnimationFrame(scroll);
};